var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M479,302.88 C471,296.044945 467,290.418278 467,286 C467,279.372583 472.372583,274 479,274 C485.627417,274 491,279.372583 491,286 C491,290.418278 487,296.044945 479,302.88 Z M479,291 C481.761424,291 484,288.761424 484,286 C484,283.238576 481.761424,281 479,281 C476.238576,281 474,283.238576 474,286 C474,288.761424 476.238576,291 479,291 Z",
    transform: "translate(-463 -272)",
    fillRule: "evenodd"
  })));
};
export default SvgLocation;